import { render, staticRenderFns } from "./DeleteImageDialog.vue?vue&type=template&id=46880e93&"
import script from "./DeleteImageDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteImageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports